import { getCSVMarketPrices } from './getCSVMarketPrices';
import { getConfigurations } from './getConfigurations';
import { updateConfigurations } from './updateConfigurations';

export const FairPrice = {
    getCSVMarketPrices,
    getConfigurations,
    updateConfigurations,
};